import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import MakeModelYearTag from "./MakeModelYearTag/MakeModelYearTag";
import stl from "./MakeModelYearTags.module.css";
import { useLocation, useParams } from "react-router-dom";
import SearchArrowSVG from "./MakeModelYearTag/SVGIcons/SearchArrowSVG";
import { useEffect, useRef, useState } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import { FACETS_YEARS_COUNT, LAST_FACET_YEAR } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
var START_YEAR = LAST_FACET_YEAR - FACETS_YEARS_COUNT;
var END_YEAR = LAST_FACET_YEAR;
var MakeModelYearTags = function MakeModelYearTags(_ref) {
  var _data$tags;
  var className = _ref.className,
    selectedOptions = _ref.selectedOptions,
    metaData = _ref.metaData,
    _ref$showYearsTags = _ref.showYearsTags,
    showYearsTags = _ref$showYearsTags === void 0 ? false : _ref$showYearsTags,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? null : _ref$baseUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var location = useLocation();
  var _useParams = useParams(),
    year = _useParams.year;
  var scrollRef = useRef(null);
  var parentRef = useRef(null);
  var anchor1 = useRef(null);
  var anchor2 = useRef(null);
  var scrollAmount = 600;
  var _useState = useState(false),
    Iscroll = _useState[0],
    setIscroll = _useState[1];
  var _useState2 = useState(false),
    IsLast = _useState2[0],
    setIsLast = _useState2[1];
  useEffect(function () {
    var handleScroll = function handleScroll() {
      if (scrollRef.current) {
        setTimeout(function () {
          checkWrapperShift();
        }, 310);
      }
    };
    if (scrollRef.current) {
      scrollRef.current.addEventListener("scroll", handleScroll);
    }
    return function () {
      if (scrollRef.current) {
        scrollRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []); // Empty dependency array ensures this effect runs only once after initial render

  var scroll = function scroll(dir, shift) {
    if (dir === "left" && scrollRef.current) {
      scrollRef.current.scrollLeft -= shift;
    } else if (dir === "right" && scrollRef.current) {
      scrollRef.current.scrollLeft += shift;
    }
  };
  var checkWrapperShift = function checkWrapperShift() {
    if (lang === "ar") {
      var _anchor1$current, _anchor1$current$getB, _parentRef$current, _parentRef$current$ge, _anchor2$current, _anchor2$current$getB, _parentRef$current2, _parentRef$current2$g;
      if (((_anchor1$current = anchor1.current) === null || _anchor1$current === void 0 ? void 0 : (_anchor1$current$getB = _anchor1$current.getBoundingClientRect()) === null || _anchor1$current$getB === void 0 ? void 0 : _anchor1$current$getB.left) > ((_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 ? void 0 : (_parentRef$current$ge = _parentRef$current.getBoundingClientRect()) === null || _parentRef$current$ge === void 0 ? void 0 : _parentRef$current$ge.right)) {
        setIscroll(true);
      } else {
        setIscroll(false);
      }
      if (((_anchor2$current = anchor2.current) === null || _anchor2$current === void 0 ? void 0 : (_anchor2$current$getB = _anchor2$current.getBoundingClientRect()) === null || _anchor2$current$getB === void 0 ? void 0 : _anchor2$current$getB.left) > ((_parentRef$current2 = parentRef.current) === null || _parentRef$current2 === void 0 ? void 0 : (_parentRef$current2$g = _parentRef$current2.getBoundingClientRect()) === null || _parentRef$current2$g === void 0 ? void 0 : _parentRef$current2$g.left)) {
        setIsLast(true);
      } else {
        setIsLast(false);
      }
    } else {
      var _anchor1$current2, _anchor1$current2$get, _parentRef$current3, _parentRef$current3$g, _anchor2$current2, _anchor2$current2$get, _parentRef$current4, _parentRef$current4$g;
      if (((_anchor1$current2 = anchor1.current) === null || _anchor1$current2 === void 0 ? void 0 : (_anchor1$current2$get = _anchor1$current2.getBoundingClientRect()) === null || _anchor1$current2$get === void 0 ? void 0 : _anchor1$current2$get.right) < ((_parentRef$current3 = parentRef.current) === null || _parentRef$current3 === void 0 ? void 0 : (_parentRef$current3$g = _parentRef$current3.getBoundingClientRect()) === null || _parentRef$current3$g === void 0 ? void 0 : _parentRef$current3$g.left)) {
        setIscroll(true);
      } else {
        setIscroll(false);
      }
      if (((_anchor2$current2 = anchor2.current) === null || _anchor2$current2 === void 0 ? void 0 : (_anchor2$current2$get = _anchor2$current2.getBoundingClientRect()) === null || _anchor2$current2$get === void 0 ? void 0 : _anchor2$current2$get.right) < ((_parentRef$current4 = parentRef.current) === null || _parentRef$current4 === void 0 ? void 0 : (_parentRef$current4$g = _parentRef$current4.getBoundingClientRect()) === null || _parentRef$current4$g === void 0 ? void 0 : _parentRef$current4$g.right)) {
        setIsLast(true);
      } else {
        setIsLast(false);
      }
    }
  };
  var createData = function createData() {
    var _metaData$seoData3;
    var make = selectedOptions.find(function (tag) {
      return tag.filterField === "make_id";
    });
    var model = selectedOptions.find(function (tag) {
      return tag.filterField === "model_id";
    });
    if (model) {
      var _metaData$seoData$yea, _metaData$seoData;
      return {
        tags: (_metaData$seoData$yea = (_metaData$seoData = metaData.seoData) === null || _metaData$seoData === void 0 ? void 0 : _metaData$seoData.years) !== null && _metaData$seoData$yea !== void 0 ? _metaData$seoData$yea : Array.from({
          length: END_YEAR - START_YEAR + 1
        }, function (_, index) {
          return END_YEAR - index;
        }),
        title: title !== null && title !== void 0 ? title : t("اختر السنة", {
          ns: "web_search"
        })
      };
    }
    if (make) {
      var _metaData$seoData2;
      var makeModels = metaData === null || metaData === void 0 ? void 0 : (_metaData$seoData2 = metaData.seoData) === null || _metaData$seoData2 === void 0 ? void 0 : _metaData$seoData2.models;
      return {
        tags: makeModels,
        title: title !== null && title !== void 0 ? title : t("اختر الموديل", {
          ns: "web_search"
        })
      };
    }
    var makes = metaData === null || metaData === void 0 ? void 0 : (_metaData$seoData3 = metaData.seoData) === null || _metaData$seoData3 === void 0 ? void 0 : _metaData$seoData3.makes;
    return {
      tags: makes,
      title: title !== null && title !== void 0 ? title : t("اختر الماركة", {
        ns: "web_search"
      })
    };
  };
  var data = createData();
  var createLink = function createLink(tag) {
    var _tag$name_en2, _tag$name_en3;
    if (baseUrl) {
      var _tag$name_en;
      return createUrl("".concat(baseUrl, "/").concat((tag === null || tag === void 0 ? void 0 : (_tag$name_en = tag.name_en) === null || _tag$name_en === void 0 ? void 0 : _tag$name_en.slugify()) || tag));
    }
    var make = selectedOptions.find(function (tag) {
      return tag.filterField === "make_id";
    });
    if (!make) return createUrl("/autos/".concat((tag === null || tag === void 0 ? void 0 : (_tag$name_en2 = tag.name_en) === null || _tag$name_en2 === void 0 ? void 0 : _tag$name_en2.slugify()) || tag));
    return createUrl("".concat(location.pathname.replace(/^(\/en)/, "").slugify(), "/").concat((tag === null || tag === void 0 ? void 0 : (_tag$name_en3 = tag.name_en) === null || _tag$name_en3 === void 0 ? void 0 : _tag$name_en3.slugify()) || tag));
  };
  if (year && !baseUrl) return null;
  if (!(data !== null && data !== void 0 && data.tags)) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-makemodelyear",
    className: "".concat(stl.wrapper, " ").concat(className || "")
  }, /*#__PURE__*/React.createElement("strong", {
    id: "posts-seo-chips-makemodelyear-title",
    className: "".concat(stl.title, " ").concat(showYearsTags ? "" : "m-hide", " ")
  }, data.title), /*#__PURE__*/React.createElement("div", {
    ref: parentRef,
    id: "posts-seo-chips-makemodelyear-scroll",
    className: [stl.parentWrapper, Iscroll ? stl.shiftStyle : undefined, IsLast ? stl.lastScroll : undefined].join(" ")
  }, (data === null || data === void 0 ? void 0 : data.tags.length) > 18 && /*#__PURE__*/React.createElement(SearchArrowSVG, {
    id: "posts-seo-chips-makemodelyear-scroll-left",
    className: stl.leftArr,
    onClick: function onClick() {
      scroll("left", scrollAmount);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.tagsWrapper,
    ref: scrollRef
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.anchor,
    ref: anchor1
  }), data === null || data === void 0 ? void 0 : (_data$tags = data.tags) === null || _data$tags === void 0 ? void 0 : _data$tags.map(function (tag, i) {
    return /*#__PURE__*/React.createElement(MakeModelYearTag, {
      key: i,
      id: "posts-seo-chip-makemodelyear-".concat(tag.id || i),
      title: tag.name || tag,
      url: createLink(tag)
    });
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.anchor,
    ref: anchor2
  })), (data === null || data === void 0 ? void 0 : data.tags.length) > 18 && /*#__PURE__*/React.createElement(SearchArrowSVG, {
    id: "posts-seo-chips-makemodelyear-scroll-right",
    className: stl.rightArr,
    onClick: function onClick() {
      scroll("right", scrollAmount);
    }
  })));
};
export default MakeModelYearTags;